import Image from "next/image";
import Link from "next/link";
import { NEWS } from "@/lib/data";
import { Reveal } from "../Reveal";

export function Innovations() {
  return (
    <section className="px-5 py-12 md:px-8 md:py-20">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <div className="mb-12 flex items-end justify-between">
            <h2 className="font-display text-4xl md:text-6xl">Dernier feu.</h2>
            <Link href="/actualites" className="text-xs tracking-[0.18em] uppercase">
              Toutes les news
            </Link>
          </div>
        </Reveal>
        <div className="grid gap-6 md:grid-cols-3">
          {NEWS.map((item, i) => (
            <Reveal key={item.slug} delay={i * 0.08}>
              <article className="group overflow-hidden border border-line">
                <div className="relative aspect-4/3 overflow-hidden">
                  <Image
                    src={item.image}
                    alt=""
                    fill
                    className="object-cover object-[center_22%] transition duration-700 group-hover:scale-105"
                    sizes="33vw"
                  />
                </div>
                <div className="p-6">
                  <p className="font-mono text-[10px] tracking-[0.2em] text-brass uppercase">{item.date}</p>
                  <h3 className="font-display mt-2 text-2xl normal-case tracking-tight">{item.title}</h3>
                  <p className="mt-3 text-sm text-mute">{item.excerpt}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
